import React from 'react';

import { uiRoutes } from '@consumer-frontend/nc-api';
import { Link } from '@consumer-frontend/shared-ui';

import { NcOsano } from './NcOsano';
import { NcSocial } from './NcSocial';

import '@consumer-bootstrap/brands/netcredit/footer.scss';
import '@consumer-bootstrap/netcredit.scss';

export type NcLinksT = React.FC;

export const NcLinks: NcLinksT = () => {
  return (
    <div className="links d-flex flex-md-row flex-column flex-grow-1 justify-content-between">
      <NcSocial />
      <div className="link-group d-flex flex-column">
        <Link to={uiRoutes.legacyAH.faq}>FAQ</Link>
        <Link to={uiRoutes.legacyAH.contactUs}>Contact Us</Link>
        <Link to={uiRoutes.legacyAH.howItWorks}>How It Works</Link>
        <Link to={uiRoutes.legacyAH.aboutUs}>Our Story</Link>
        <Link to={uiRoutes.legacyAH.ratesAndTerms}>Rates and Terms</Link>
      </div>
      <div className="link-group d-flex flex-column">
        <Link to={uiRoutes.legacyAH.personalLoans}>Personal Loans</Link>
        <Link to={uiRoutes.legacyAH.lineOfCredit}>Lines of Credit</Link>
        <Link to={uiRoutes.legacyAH.badCreditLoans}>Loans for Bad Credit</Link>
        <Link to={uiRoutes.legacyAH.noCreditCheckOnlineLoans}>No Credit Check Loans</Link>
        <Link to={uiRoutes.legacyAH.quickLoans}>Quick Loans</Link>
      </div>
      <div className="link-group d-flex flex-column">
        <Link to={uiRoutes.legacyAH.termsOfUse}>Terms of Use</Link>
        <Link to={uiRoutes.legacyAH.privacyPolicy}>Privacy Policy</Link>
        <Link to={uiRoutes.legacyAH.statesPrivacyPolicy}>States Privacy Policy</Link>
        <Link to={uiRoutes.legacyAH.californiaCollectionNotice}>California Collection Notice</Link>
        <Link to={uiRoutes.legacyAH.optOut}>Opt Out</Link>
        <NcOsano />
      </div>
      <div className="link-group d-flex flex-column">
        <Link to={uiRoutes.legacyAH.blog}>Blog</Link>
        <Link to={uiRoutes.legacyAH.financialResources}>Financial Resources</Link>
        <Link to={uiRoutes.legacyAH.siteMap}>Sitemap</Link>
      </div>
    </div>
  );
};
